import { PageDataError } from 'src/shared/error';

import type { HomepageTrendingSectionQuery } from '../api.graphql';

export type HomepageTrendingPetitionItem = NonNullable<HomepageTrendingSectionQuery['trendingPetitions']>;

export type HomepageTrendingSectionDataErrorCode = 'homepage_trending_section_data_not_found';
export class HomepageTrendingSectionDataError extends PageDataError<HomepageTrendingSectionDataErrorCode> {}
